export default "__VITE_ASSET__DHWgQJXB__"